import { forwardRef } from 'react';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import { Button, type ButtonProps } from '@mui/material';

export type FilterToolbarButtonProps = Omit<ButtonProps, 'endIcon' | 'size' | 'sx' | 'variant'>;

/** One trigger treatment for the compact controls that sit beside list filters. */
export const FilterToolbarButton = forwardRef<HTMLButtonElement, FilterToolbarButtonProps>(
  ({ children, ...props }, ref) => {
    const expanded = props['aria-expanded'] === true;

    return (
      <Button
        {...props}
        ref={ref}
        endIcon={
          <KeyboardArrowDownRoundedIcon
            sx={{
              fontSize: '1rem !important',
              transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 140ms ease',
            }}
          />
        }
        size="small"
        sx={{
          bgcolor: 'background.paper',
          borderColor: 'divider',
          color: 'text.primary',
          fontWeight: 600,
          height: 32,
          px: 1.25,
          textTransform: 'none',
          whiteSpace: 'nowrap',
          '&:hover': {
            bgcolor: 'action.hover',
            borderColor: 'text.disabled',
          },
          '& .MuiButton-endIcon': { ml: 0.5 },
          '& .MuiButton-startIcon': { mr: 0.75 },
          '@media (prefers-reduced-motion: reduce)': {
            '& .MuiButton-endIcon svg': { transition: 'none' },
          },
        }}
        variant="outlined"
      >
        {children}
      </Button>
    );
  },
);

FilterToolbarButton.displayName = 'FilterToolbarButton';
